const { Auth } = require("aws-amplify");
const { API, graphqlOperation } = require("aws-amplify");
const {
  createEqutWebSession,
  createEqutWebSessionWithTtl,
  updateEqutWebSession,
} = require("@/graphql/mutations");
const {
  getEqutWebSession,
} = require("@/graphql/queries");
const short = require('short-uuid');
const UserInfo = require('../appUtils/UserInfo');

const DateUtil = require('../appUtils/DateUtil');

class Session {  
  constructor(sessionId) {
    this.sessionId = sessionId
    this.newSession = false
    if (!sessionId) {
      
      this.sessionId = short.generate()
      
      this.newSession = true
    }
  }

  /**
   * 非同期で初期化処理を行いインスタンスを返す。このクラスを使用する場合はこのメソッドを呼び出す。
   * ex. let session = await Session.init()
   * sessionIdはVuexで持ち回っておく
   * @returns 
   */
  static async init(sessionId = null) {
  
    let session = new Session(sessionId)
    
    if (session.newSession) {
      const user = await UserInfo.getUserInfo()
      // ログインユーザのSubを登録
      session.userSub = user.sub
      
      session.setupNewRow()
      session.setupNewSession()
      // テナントIDをセット
      session.info.tenant.id = user.group

      // TTLをセット
      // let ttl = DateUtil.getTtlOfDayElapsed()
      // session.row._ttl = ttl
      await session.update()

    } else {
      let result = await Auth.currentUserInfo();
      session.userSub = result.attributes.sub
      // DBのセッション情報を取得する
      await session.get()
    }
    return session
  }

  async get() {
    let result = await API.graphql(
      graphqlOperation(getEqutWebSession, { owner: this.userSub, sessionId: this.sessionId })
    );
    // 以下の戻り値
    // {
    //   id: ID! 
    //   owner: String!
    //   sessionId: String!
    //   info: String
    // }
    this.row = result.data.getEqutWebSession
    this.info = JSON.parse(result.data.getEqutWebSession.info)
  }

  /**
   * create or updateを行う
   */
  async update(){
    let input = Object.assign({}, this.row)
    input.info = JSON.stringify(this.info)
    
    if (this.newSession) {
      await API.graphql(

        graphqlOperation(createEqutWebSession, { input: input})
      );
    } else {
      await API.graphql(
        graphqlOperation(updateEqutWebSession, { input: input})
      );
    }
  }

  setupNewRow() {
    let row = {
      owner: this.userSub,
      sessionId: this.sessionId,
      info: ""
    }
    this.row = row
  }
  /**
   * 空のセッション情報
   */
  setupNewSession() {
    let session = {
      tenant: {
        id: "",
      },
      todo: {
        drawer: false,
        edit: false,
        data: null,
        size: "300px",
      },
      notice: {
        drawer: false,
        edit: false,
        data: null,
        size: "300px",
      },
      inspectForm: {
        sk: null,
        isCopy: false

      },
      project: {},
      editUserParams: {
        editUserId: null,
        createFlg: false,
        fromNavbar: false,
      },
      meeting: {
        selectedMeetingData: {},
        meeting: {},
        attendee: {},
        provider: {},
        meetingSession: {},
        meetingList: [],
        audioInputList: [],
        videoInputList: [],
        wipe: false,
        fullScreen: false
      },
      user: "",
      loginUser: {},
      selectedNode: null,
      measureDetailData: null,
      maintenance: {
        message: "",
        start: "",
        end: "",
      },
      tenantStorage: null
    };

    this.info = session
  }
}

module.exports = Session;